import appSettings from "../appSettings.js";
import templateUri from "../templateUri.ts";
import { User } from "../Models/User.js";
import { EventTypeInput } from "../Models/EventType";
import { OtsAircraft } from "../Models/OtsAircraft.js";
import { ClosedSearchParams, ClosedSortingParams } from "../Models/ClosedSearchParams";
import { AogPartInputParams } from "../Models/Orderpart";



interface Notes {
    DateTimeAdded: string;
    AddedByFirstName: string;
    AddedByLastName: string;
    NoteText: string;
}
export async function createOTSEvent(user: User, data: any) {

  //Temp for adding user name to data
  data.updatedBy = user?.profile?.name;
  data.createdBy = user?.profile?.name;
  //Data points for Twilio
  let firstName =
    user?.profile?.given_name != null ? user?.profile?.given_name : "Unkown";

  data.updatedByFirstName = firstName;
  data.updatedByLastName = user?.profile?.family_name;
  data.updatedByEmail = user?.profile?.email;
  data.airline = user?.profile?.company;
  const email = user?.profile?.email;
  const token = user?.access_token;

  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}`;
  const response = await fetch(uri, {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return await response.status;
}

export async function getAircraftAndEtopsIndicatorList(user: User) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.etopsAircraftPath}?airline=${airline}`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });

  let json = await response.json();
  console.log("getAircraftAndEtopsIndicatorList: ", json);
  let list: AircraftandEtopsIndicator[] = json;

  return list;
}

export async function getLocation(user: User, tail: any) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  let uri = `${appSettings.API_BASE_URL}${templateUri.stationSETDPath}`;
  uri = uri.replace("{airline}", user?.profile?.company);
  uri = uri.replace("{aircraftRegistration}", tail);
  
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 200) {    
      let json = await response.json();
      let stationSETD: AircraftStationSETD = json;
      stationSETD.Station= stationSETD.Station ?? "";
      stationSETD.Location = stationSETD.Location ?? "";
      stationSETD.SETD = stationSETD.SETD ?? "";
      return stationSETD;
  } else {
     throw new Error(`Location service returned: ${response.status}`);
  }
  
}

export async function getATAList(user: User) {
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.ataCodePath}?airline=${airline}`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    //throw errer if status is 204 too (as ATA codes won't be usable) or any other status
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export async function getOpenEvents(user: User, selectedEventType: string, computeETD?: boolean) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}?airline=${airline}`;
  
  if (selectedEventType) { 
    uri = uri + `&EventType=${encodeURIComponent(selectedEventType)}`;
  }
  if (computeETD === false) {
    uri = uri + `&computeETD=${computeETD}`;
  }
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
        authorization: `Bearer ${token}`,
          "continousToken":""
    },
  });

  if (response.status === 200) {
    return await response.json();
  }
  else if (response.status === 204) { return []; }
  else {
    return null;
  }
}

export async function getOtsHistory(user: User, aircraftNumber: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;

  let uri = `${appSettings.API_BASE_URL}${templateUri.otsHistoryPath}?airline=${airline}&aircraftRegistration=${aircraftNumber}`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });

  if (response.status === 200) {
    return await response.json();
  } else {
    return [];
  }
}

export async function getFlightPath(user: User, aircraftNumber: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  const date = new Date();
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are 0 based, so add 1 and format as 2 digits
  const day = ("0" + date.getDate()).slice(-2); // Format day as 2 digits

  const flightDate = `${year}-${month}-${day}`;
  let uri = `${appSettings.API_BASE_URL}${templateUri.flightPath}?airline=${airline}&aircraftRegistration=${aircraftNumber}&flightDate=${flightDate}`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });
  return await response.json();
}

export async function getOtsEvent(
  user: User,
  airlineCode: string,
  aircraftRegistration: string,
  id: string
) {
 
  const email = user?.profile?.email;
  const token = user?.access_token;

  let uri = `${appSettings.API_BASE_URL}${
    templateUri.outofserviceRecoveryEventPath}/${encodeURIComponent(airlineCode)}/aircraft/${encodeURIComponent(
    aircraftRegistration
  )}/events/${encodeURIComponent(id)}`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });

  return await response.json();
}

export async function updateOtsEvent(user: User, data: any) {
  const email = user?.profile?.email;
  const token = user?.access_token;

  //adding user name to data
  data.lastUpdatedBy = user?.profile?.name;
  //Data points for Twilio
  data.updatedByFirstName = user?.profile?.given_name;
  data.updatedByLastName = user?.profile?.family_name;
  data.updatedByEmail = user?.profile?.email;

  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}`;
  const response = await fetch(uri, {
    method: "PUT",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  const statusCode = response.status;
  let responseData;
  
  try {
    const rawResponse = await response.text();
    responseData = JSON.parse(rawResponse);
    
    if (!Array.isArray(responseData)) {
      responseData = [responseData];
    }
    
    // Remove any quotes from each string in the array
    responseData = responseData.map(item => 
      typeof item === 'string' ? item.replace(/^(?:"|")$/g, '') : item
    );
  } catch (e) {
    console.error("Error parsing response data", e);
    responseData = ["Error parsing response data"];
  }
  
  return { statusCode, responseData };
}

export async function getClosedEvents(user: User, searchParams?: ClosedSearchParams, sortingParams?: ClosedSortingParams, continousToken?: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.closedEvents}?airline=${airline}`;
  
  // Add optional query parameters
  if (sortingParams?.sortBy) {
    uri += `&SortBy=${encodeURIComponent(sortingParams.sortBy)}`;
  }
  if (sortingParams?.sortOrder) {
    uri += `&SortOrder=${encodeURIComponent(sortingParams.sortOrder)}`;
  }

  const response = await fetch(uri, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
      "Continous-Token": continousToken || "",
    },
    body: JSON.stringify(searchParams),
  });

  if (response.status === 200) {
    return await response.json();
  } else if (response.status === 204) {
    return null; // Return null for No Content
  } else {
    throw new Error(`Error fetching closed events: ${response.statusText}`);
  }
}

export async function getClosedEventsReport(user: User, searchParams?: ClosedSearchParams, sortingParams?: ClosedSortingParams, timeZone?: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.closedEventsReport}?airline=${airline}`;

  // Add optional query parameters
  if (sortingParams?.sortBy) {
    uri += `&SortBy=${encodeURIComponent(sortingParams.sortBy)}`;
  }
  if (sortingParams?.sortOrder) {
    uri += `&SortOrder=${encodeURIComponent(sortingParams.sortOrder)}`;
  }

 try {
  const response = await fetch(uri, {
    method: "POST",
    mode: "cors",
    headers: {
      "Accept": "text/csv",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
      "TimeZone": timeZone || "",
    },
    body: JSON.stringify(searchParams),
  });

  return response;
 }catch (error) {
  throw new Error(`Error fetching closed events report`);
 }
}





export async function getClosedEventsFilterCount(user: User, closedSearchParams?: ClosedSearchParams) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
    let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${airline}/aircraft/getclosedeventscount`;

  const response = await fetch(uri, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(closedSearchParams),
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    return 0;
  }
}

export async function canReopenEvent(user: User, data: OtsAircraft) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.canReopenEvent}${airline}/aircraft/N${data.AircraftRegistration}/events/${data.id}/reopen`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    }
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    return null;
  }
}

export async function getActiveEventTypes(token: string, airline: string, email: string) {

   let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${airline}/eventtypes?activeOnly=true`;
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    console.log("GetEventTypes URL  call failed");
    return [];
  }
}

export async function getEventTypes(token: string, airline: string, email: string) {
  if (airline !== undefined && airline !== null && airline !== "") {
     let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${airline}/eventtypes?activeOnly=false`;
    console.log("GetEventTypes URL: ", uri);
    const response = await fetch(uri, {
      method: "GET",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Email-Id": email,
        authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      return await response.json();
    } else if (response.status === 204) {
      return [];
    }
    else {
      console.log("GetEventTypes URL  call failed");
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }
}

export async function createEventType(user: User, input: EventTypeInput) {
  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${user.profile.company}/eventtypes`;
  const response = await fetch(uri, {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": user.profile.email,
      authorization: `Bearer ${user.access_token}`,
    },
    body: JSON.stringify(input)
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    console.log("EventTypeInput", input);
    console.log("createEventTypes URL  call failed");
    return [];
  }
}

export async function updateEventType(user: User, input: EventTypeInput) {
  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${user.profile.company}/eventtypes/${input.Id}`;
  
  const response = await fetch(uri, {
    method: "PUT",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": user.profile.email,
      authorization: `Bearer ${user.access_token}`,
    },
    body: JSON.stringify(input)
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    console.log("updateEventTypes URL  call failed");
    return [];
  }
}

export async function eventTypeHasActiveEvent(user: User, eventType: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  if (airline !== undefined && airline !== null && airline !== "") {
     let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${airline}/eventtypes/${eventType}/deactivate`;
    console.log("GetHasActiveEvent URL: ", uri);
    const response = await fetch(uri, {
      method: "GET",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Email-Id": email,
        authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      return await response.json();
    } else if (response.status === 204) {
      return null;
    } else {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  }
}

export async function checkAirborneStatusForCreateOTS(user: User, aircraftRegistration: string) {
  let uri = `${appSettings.API_BASE_URL}${templateUri.outofserviceRecoveryPath}/airlines/${user.profile.company}/aircraft/N${aircraftRegistration}/events/airborne`;
  
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      "Email-Id": user.profile.email,
      authorization: `Bearer ${user.access_token}`,
    },
  });
  if (response.status === 200) {
    return await response.json();
  } else {
    console.log("updateEventTypes URL  call failed");
    throw new Error(`HTTP error! status: ${response.status}`);
  }
}

export async function checkForEventReload(user:User, lastReloadTime: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  if (airline !== undefined && airline !== null && airline !== "") {
    let uri = `${appSettings.API_BASE_URL}${templateUri.refreshEventType}/${airline}/events/reload?lasttimestamp=${encodeURIComponent(lastReloadTime)}`;

     const response = await fetch(uri, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "Email-Id": email,
          authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      return await response.json();
    } else {
      console.log("Get event data reload URL call failed");
      return [];
    }
  } 
}

export async function getAircraftList(user: User) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.getAllAircraftsPath}?airline=${airline}`;
  console.log("uri aa: ", uri);
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });

  let json = await response.json();
  console.log("getAircraftList: ", json);
  let list: any[] = json;

  return list;
}

export async function getAircraftInFleet(user: User, fleetCode: string) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  let uri = `${appSettings.API_BASE_URL}${templateUri.getAircraftInFleet}`;
  uri = uri.replace("{airline}", airline);
  uri = uri.replace("{fleetCode}", fleetCode);
  console.log("uri aa: ", uri);
  const response = await fetch(uri, {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "Email-Id": email,
      authorization: `Bearer ${token}`,
    },
  });
    if (response.status === 200) {
        const json = await response.json();
        console.log("getAircraftInFleet: ", json);
        return json;
    } else if (response.status === 204) {
        return null;
    } else {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
}

export async function getSyncStatus(user:User) {
  const email = user?.profile?.email;
  const token = user?.access_token;
  const airline = user?.profile?.company;
  if (airline !== undefined && airline !== null && airline !== "") {
    let uri = `${appSettings.API_BASE_URL}${templateUri.syncStatus}`;
    uri = uri.replace("{airline}", airline);
     const response = await fetch(uri, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        "Email-Id": email,
          authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      console.log("Get Sync Status URL call response", response);
      const json = await response.json();
      const stat: SyncStatus = {
        IsOutOfSync: json.IsOutOfSync
      };
      return stat;
    } else {
      return null;
    }
  } 
}
export async function getFleetTypes(user: User) {
    const email = user?.profile?.email;
    const token = user?.access_token;
    const airline = user?.profile?.company;
    if (airline !== undefined && airline !== null && airline !== "") {
        let uri = `${appSettings.API_BASE_URL}${templateUri.getFleetTypespath}?airline=${airline}`;
        console.log("GetFleetTypeEvent URL: ", uri);
        const response = await fetch(uri, {
            method: "GET",
            mode: "cors",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Email-Id": email,
                authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            return await response.json();
        } else {
            console.log("GetFleetTypeEvent URL call failed");
            return [];
        }
    }
}

export async function getAogParts(user: User, eventId: string) {
    const email = user?.profile?.email;
    const token = user?.access_token;
    const airline = user?.profile?.company;
    if (airline !== undefined && airline !== null && airline !== "") {
        let uri = `${appSettings.API_BASE_URL}${templateUri.aogPartsPath}`;
        uri = uri.replace("{airline}", airline);
        uri = uri.replace("{eventId}", String(eventId));
        const response = await fetch(uri, {
            method: "GET",
            mode: "cors",
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                "Email-Id": email,
                authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            return await response.json();
        } else if (response.status === 204) {
            return null;
        } else {
            console.log("GetAogParts URL call failed");
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    }
}

export async function postAogParts(user: User, input: AogPartInputParams) {
  const email = user?.profile?.email;
  const token = user?.access_token;

    let uri = `${appSettings.API_BASE_URL}${templateUri.aogPartsPath}`;
    uri = uri.replace("{airline}", input.Airline);
    uri = uri.replace("{eventId}", input.OtsEventId);

    const response = await fetch(uri, {
      method: "POST",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "Email-Id": email,
        "authorization": `Bearer ${token}`,
      },
      body: JSON.stringify(input),
    });

    if (response.status === 201 || response.status === 200) {
      return await response.json();
    } else {
      console.log("PostAogParts URL call failed");
      throw new Error(`HTTP error! status: ${response.status}`);
    }
}

